// Split Lines
export function splitLines(containers) {
  Array.prototype.forEach.call(containers, (elem) => {
    let split = elem.innerText.split("\n");

    let result = split.map((splitString) => {
      return '<span class="new-line">' + splitString + "</span>";
    });

    elem.innerHTML = result.join(" ");
  });
}
